import styled from "styled-components";

import { AuthModalBottomDescription } from "../../atoms/AuthModalBottomDescription/styles";
import { AuthModalButtonContainer } from "../../atoms/AuthModalButton/styles";

export const ForgotPasswordContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;

  max-width: 360px;
  margin: 0 auto;

  padding-bottom: 4.125rem;

  ${AuthModalButtonContainer} {
    width: 100%;
  }

  ${AuthModalBottomDescription} {
    margin-top: 1rem;
  }

  .auth-modal-forgot-reset-btn {
    box-shadow: 0px 2px 40px 0px #00000040;
  }

  #forgot-password-create-account {
    text-wrap: balance;
    height: auto;
  }

  .loader {
    width: 1rem;
    height: 1rem;
  }

  animation: appearFromLeft 0.4s;

  .editor-input {
    display: grid;
    place-items: center;
    padding: 0 !important;

    * {
      text-align: center !important;
      font-size: 0.813rem !important;
      line-height: 20px !important;
    }
  }

  @keyframes appearFromLeft {
    from {
      opacity: 0;
      transform: translateX(-5px);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;

export const AuthModalForgetPasswordForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 1rem;
`;
